import * as React from "react";
import clsx from "clsx";

interface OwnProps {
  col: string;
  setSortColumn: (col: string, order: "ASC" | "DESC") => void;
  currentCol: string;
  currentOrder: string;
}

export const SortArrows: React.FC<OwnProps> = (props) => {
  let upActive = false;
  let downActive = false;

  if (props.col === props.currentCol) {
    upActive = props.currentOrder === "ASC";
    downActive = props.currentOrder === "DESC";
  }

  return (
    <>
      <button
        className={clsx("btn btn-link ml-2", { "bg-light": upActive })}
        onClick={(e) => {
          e.preventDefault();
          props.setSortColumn(props.col, "ASC");
        }}
        type="button"
      >
        <i className="fe fe-arrow-up" />
      </button>
      <button
        className={clsx("btn btn-link ml-2", { "bg-light": downActive })}
        onClick={(e) => {
          e.preventDefault();
          props.setSortColumn(props.col, "DESC");
        }}
        type="button"
      >
        <i className="fe fe-arrow-down" />
      </button>
    </>
  );
};
